import React from 'react';
import { Card, Typography, Row, Col, Progress } from 'antd';
import Explainer from '../../../components/Explainer';
const { Text, Title } = Typography;

const GREEN = '#0ccd93';
const RED = '#f74a4a';

const CaptureRatios = ({ upside, downside}) => {
    const relativeDifference = (upside / downside) * 50; // This will determine where the center line will be
  let centerLinePercent = Math.floor(Math.min(Math.max(relativeDifference, 0), 100)); // Bound the value between 0 and 100
  if (centerLinePercent < 0){
     centerLinePercent = 0;
  }
  if (centerLinePercent > 100){
    centerLinePercent = 100;
  }



  // Step 2: Define color based on relative strength

  return (
    <Card title={<Explainer title={'Capture Ratios'} tooltip={'Upside and Downside Capture to the Benchmark'} />}
          bordered={false}>
      <div style={{ padding: '20px 10px', textAlign: 'center' }}>
      <Row gutter={16}>
        <Col span={12}>
          <Text strong color={'green'} style={{ color: 'green', fontSize: '1.5em' }}>{upside?.toFixed(1)}%</Text>
        </Col>
        <Col span={12}>
          <Text strong style={{ color: 'red', fontSize: '1.5em' }}>{downside?.toFixed(1)}%</Text>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Progress
            percent={100}
            showInfo={false}
            strokeColor={{
              '0%': GREEN,
                [`${centerLinePercent}%`]: GREEN,
              [`${centerLinePercent+1}%`]: RED,
              '100%': RED,
            }}
            strokeLinecap="round"
            strokeWidth={15}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Typography.Text style={{fontSize: '11px', fontWeight: '500'}}>Compares Upside & Downside Performance to the portfolios benchmark</Typography.Text>
        </Col>
      </Row>
    </div>
    </Card>
  );
};

export default CaptureRatios;
